var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuotationMarks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#000",
      fillOpacity: 1
    },
    d: "M24.295 26.864c-5.094-5.719-1.585-15.673 2.657-19.522 3.615-3.28 9.605-5.96 10.17-5.024.897 1.49-2.636 2.547-5.293 4.938-3.316 3.586-4.43 5.198.16 7.221 4.918 2.22 5.012 4.391 5.17 7.153.398 6.954-7.89 10.207-12.864 5.234zM5.123 26.765C.028 21.046 3.538 11.09 7.78 7.243c3.614-3.28 9.604-5.96 10.17-5.024.897 1.49-2.636 2.547-5.293 4.938-3.316 3.586-4.43 5.198.159 7.221 4.918 2.22 5.013 4.391 5.17 7.153.399 6.954-7.89 10.207-12.863 5.234z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotationMarks);
export default __webpack_public_path__ + "static/media/quotation-marks.049dd7b6eb0ec2834375198bc903aa6a.svg";
export { ForwardRef as ReactComponent };